import{getCurrentScope as e}from"@sentry/react";var r=function(r,t){e().addBreadcrumb({category:"eec event",message:r,level:"info",data:t,type:"info"})};export{r as logWithSentryEEC};
//# sourceMappingURL=sentry.js.map
